// Per-field serialization rules for the persona form's submit payload. Adding
// a field with custom serialization means adding an entry here rather than
// growing a switch statement embedded in the submit handler.
const FIELD_TRANSFORMERS: Record<string, (formData: Record<string, any>) => any> = {
  pf_default_language: (formData) =>
    formData.pf_default_language.key ? formData.pf_default_language.key : null,
  pf_excluded_languages: (formData) =>
    formData.pf_excluded_languages?.length
      ? formData.pf_excluded_languages.map((lang: any) => lang.key)
      : null,
  pf_pages: (formData) => (formData.pf_pages.length ? formData.pf_pages : null),
  pf_words_blacklist: (formData) =>
    formData.pf_words_blacklist.length ? formData.pf_words_blacklist : null,
  pf_cta: (formData) => (formData.pf_role === 'sales' ? formData.pf_cta || null : null),
  pf_icp: (formData) => (formData.pf_role === 'sales' ? formData.pf_icp || null : null),
  pf_tone_of_voice_emoji: (formData) =>
    typeof formData.pf_tone_of_voice_emoji !== 'undefined' ? formData.pf_tone_of_voice_emoji : null,
  pf_company_description: (formData) => formData.pf_company_description || '',
};

// Workflow fields are sourced from the current inputData, not the form -
// they're edited via separate workflow state, not the persona form fields.
const WORKFLOW_FIELD_KEYS = new Set(['pf_default_workflow', 'pf_custom_workflows']);

export const buildPersonaSettingsPayload = (
  formData: Record<string, any>,
  formFieldsObject: Record<string, any>,
  inputData: Record<string, any> | null,
) => {
  const cleanedFormData = { ...formData };
  delete cleanedFormData.pf_words_blacklist_item;
  delete cleanedFormData.pf_role_click_value;
  delete cleanedFormData.pf_tone_of_voice_style_click_value;

  return Object.keys(formFieldsObject).reduce((payload: Record<string, any>, key) => {
    if (WORKFLOW_FIELD_KEYS.has(key)) {
      if (inputData && typeof inputData[key] !== 'undefined') {
        payload[key] = inputData[key];
      }
      return payload;
    }

    const transform = FIELD_TRANSFORMERS[key];
    payload[key] = transform ? transform(cleanedFormData) : cleanedFormData[key] || null;

    return payload;
  }, {});
};
